import { useQuery } from "@tanstack/react-query"

import axios from "axios"

import { useThreeDStudioStore } from "Pods/ThreeDStudio/Store"

export const BACKGROUND_IMAGES_QUERY_KEY = ["generatorBackgroundImages"]
export const BACKGROUND_IMAGES_ENDPOINT = "/api/internal/generator/background_images"
const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000

export async function fetchBackgroundImages() {
  const { data } = await axios.get(BACKGROUND_IMAGES_ENDPOINT)
  return data?.data ?? []
}

function useBackgroundImages() {
  const isModelLoaded = useThreeDStudioStore(state => Boolean(
    state.ui?.openedModel?.outputAssets?.[0]?.fileUrl
    || state.modelSettings?.inputThreeDUrl,
  ))
  // The endpoint serves the template HDRIs to anonymous visitors too, so a shared model
  // renders in its lit environment whether or not the viewer has an account.
  const { data, isLoading, isError } = useQuery({
    queryKey: BACKGROUND_IMAGES_QUERY_KEY,
    queryFn: fetchBackgroundImages,
    enabled: isModelLoaded,
    staleTime: ONE_DAY_IN_MS,
  })

  return {
    images: data ?? [],
    isLoading: isModelLoaded && isLoading,
    isError,
  }
}

export default useBackgroundImages
